export enum Status {
  ADD_ROWS = 'Add Rows',
  UPDATE_ROWS = 'Update Rows',
  DELETE_ROWS = 'Delete Rows',
}

export type TypeEditableTitle = (value: string) => void
